var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingTrialCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 9.10547V5.10547H4V9.10547H20ZM20 11.1055H4V19.1055H20V11.1055ZM3 3.10547H21C21.2652 3.10547 21.5196 3.21083 21.7071 3.39836C21.8946 3.5859 22 3.84025 22 4.10547V20.1055C22 20.3707 21.8946 20.625 21.7071 20.8126C21.5196 21.0001 21.2652 21.1055 21 21.1055H3C2.73478 21.1055 2.48043 21.0001 2.29289 20.8126C2.10536 20.625 2 20.3707 2 20.1055V4.10547C2 3.84025 2.10536 3.5859 2.29289 3.39836C2.48043 3.21083 2.73478 3.10547 3 3.10547ZM5 12.1055H8V17.1055H5V12.1055ZM5 6.10547H7V8.10547H5V6.10547ZM9 6.10547H11V8.10547H9V6.10547Z",
    fill: "#465C6F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTrialCalendar);
export default __webpack_public_path__ + "static/media/onboarding-trial-calendar.6adb874b3e2752c6ea88795b8e09eeab.svg";
export { ForwardRef as ReactComponent };